import { type FC } from "react";
import { LocationSelect } from "./LocationSelect";

interface Props {
    outlets: Array<{
        id: string;
        name: string;
        registers: Array<{
            id: string;
        }>;
    }>;
    onOutletSelect: (outlet: "global" | string) => void;
    previousRegister: string | null;
}

export const LocationOutletSelector: FC<Props> = ({
    outlets,
    onOutletSelect,
    previousRegister,
}) => {
    return (
        <div className="pt-8">
            <p className="mb-2">Which outlet are you currently in?</p>
            <div>
                {outlets.map(outlet => (
                    <LocationSelect
                        {...outlet}
                        onSelect={onOutletSelect}
                        key={outlet.id}
                        icon="map-pin"
                        previous={
                            previousRegister !== null &&
                            outlet.registers.filter(register => register.id === previousRegister).length !== 0
                        }
                    />
                ))}
                <LocationSelect
                    id="global"
                    name="Not at an Outlet"
                    onSelect={onOutletSelect}
                    icon="globe-asia"
                    previous="(Global Mode)"
                />
            </div>
        </div>
    );
};
